/**
 * Главная (`front-page.php`): четыре слайдера.
 *
 * Перенесено из `assets/js/page-front.js` (`initSliders`), опции 1:1.
 * Swiper — из npm, а не вендорный `swiper-bundle.min.js`: на главной
 * он снят (`functions.php`, блок `is_front_page()`).
 *
 * | Слайдер | Якорь | Стрелки / точки |
 * |---|---|---|
 * | отзывы | `.reviews--front-page .reviews__slider` | `.reviews__slider-actions` |
 * | блог | `.posts__slider` | `.posts__actions` |
 * | медиа | `.media__slider` | `.media__actions` |
 * | бизнес | `.business__slider` | — (бегущая лента) |
 *
 * 🔴 Управление ищется ВНУТРИ своей секции и передаётся элементом,
 * а не строкой: строку Swiper ищет по всему документу. На главной
 * три одинаковых `.swiper-button-next`, и общий селектор уже давал
 * баг — стрелки «Блога» и «Медиа» листали отзывы (2026-11-02).
 *
 * Модификатор нужен только отзывам: `.reviews__slider` есть ещё
 * на `/silavslove/`. Классы `posts__`, `media__`, `business__`
 * с JS-нагрузкой — только в `front-page.php` (`.posts__slider` в
 * `single.php` — другой блок `popular-posts__slider`).
 *
 * Эталон поведения ДО переноса снят на 380/992/1440:
 * `.tmp/js-audit/front-reviews-before.json`, `front-sliders-before.json`.
 */

/**
 * Отзывы. 👤 2026-11-03: точки кликабельны — в легаси `clickable`
 * не был задан, переключать можно было только стрелками.
 */
const REVIEWS = {
    loop: true,
    slidesPerView: 1,
    breakpoints: {
        992: {
            slidesPerView: 3,
            spaceBetween: 40,
        },
    },
};

/** Блог и медиа: одинаковые опции. */
const CARDS = {
    loop: true,
    slidesPerView: 1,
    breakpoints: {
        992: {
            slidesPerView: 3,
            spaceBetween: 40,
        },
    },
};

/**
 * Бизнес: бегущая лента логотипов.
 *
 * ⚠️ `delay: 0` + `speed: 2000` дают непрерывное движение только вместе
 * с `transition-timing-function: linear` на `.swiper-wrapper` —
 * правило лежит в `assets/css/front-page-mod.css`, без него лента
 * будет дёргаться с замедлением на каждом слайде.
 */
const BUSINESS = {
    loop: true,
    grabCursor: true,
    autoHeight: false,
    speed: 2000,
    slidesPerView: 1.8,
    spaceBetween: 20,
    autoplay: {
        delay: 0,
        disableOnInteraction: true,
    },
    breakpoints: {
        992: {
            spaceBetween: 20,
            slidesPerView: 5.5,
        },
    },
};

/** Стрелки из контейнера управления — элементами, не строкой. */
function navigationIn(actions) {
    return {
        nextEl: actions && actions.querySelector('.swiper-button-next'),
        prevEl: actions && actions.querySelector('.swiper-button-prev'),
    };
}

export default async function FrontPage() {
    const reviewsSection = document.querySelector('.reviews--front-page');
    const nodes = {
        reviews: reviewsSection && reviewsSection.querySelector('.reviews__slider'),
        posts: document.querySelector('.posts__slider'),
        media: document.querySelector('.media__slider'),
        business: document.querySelector('.business__slider'),
    };

    if (!Object.values(nodes).some(Boolean)) return;

    // Модули перечисляются явно: в npm-сборке без них стрелки, точки
    // и автопрокрутка молча не заработают
    const [{ default: Swiper }, { Navigation, Pagination, Autoplay }] = await Promise.all([
        import('swiper'),
        import('swiper/modules'),
    ]);

    if (nodes.reviews) {
        const actions = reviewsSection.querySelector('.reviews__slider-actions');

        new Swiper(nodes.reviews, {
            ...REVIEWS,
            modules: [Navigation, Pagination],
            navigation: navigationIn(actions),
            pagination: {
                el: actions && actions.querySelector('.swiper-pagination'),
                clickable: true,
            },
        });
    }

    for (const key of ['posts', 'media']) {
        if (!nodes[key]) continue;

        new Swiper(nodes[key], {
            ...CARDS,
            modules: [Navigation],
            navigation: navigationIn(document.querySelector(`.${key}__actions`)),
        });
    }

    if (nodes.business) {
        new Swiper(nodes.business, { ...BUSINESS, modules: [Autoplay] });
    }
}
